import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { PhoneLocationSettings } from './PhoneLocationSettings'
import { PhoneNumbers } from './PhoneNumbers'

export const PhoneSpecificSettings = (): ClickNavigationSection[] => {
  return [
    { id: 'phoneNumbers', label: 'Phone Numbers', content: () => <PhoneNumbers /> },
    { id: 'location', label: 'Zocks Contact Card', content: () => <PhoneLocationSettings /> },
  ]
}
